import {
  AudioPlugin,
  FilePlugin,
  ImagePlugin,
  MediaEmbedPlugin,
  VideoPlugin,
} from '@platejs/media/react';
import { KEYS } from 'platejs';

import { AudioElement } from 'src/components/ui/editor/ui/media-audio-node';
import { MediaEmbedElement } from 'src/components/ui/editor/ui/media-embed-node';
import { FileElement } from 'src/components/ui/editor/ui/media-file-node';
import { ImageElement } from 'src/components/ui/editor/ui/media-image-node';
import { MediaPreviewDialog } from 'src/components/ui/editor/ui/media-preview-dialog';
import { VideoElement } from 'src/components/ui/editor/ui/media-video-node';

export const MediaKit = [
  ImagePlugin.configure({
    options: { disableUploadInsert: true },
    render: { afterEditable: MediaPreviewDialog, node: ImageElement },
  }),
  MediaEmbedPlugin.withComponent(MediaEmbedElement),
  VideoPlugin.withComponent(VideoElement),
  AudioPlugin.withComponent(AudioElement),
  FilePlugin.withComponent(FileElement),
];
